import { inject } from '@angular/core';
import {
  setError,
  setLoaded,
  setLoading,
  withCallState,
  withDevtools,
} from '@angular-architects/ngrx-toolkit';

import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withMethods, withProps } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { exhaustMap, pipe, tap } from 'rxjs';

import {
  ExportType,
  OverviewFilters,
  OverviewService,
} from './overview.service';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const OverviewExportStore = signalStore(
  { providedIn: 'root' },
  withDevtools('overviewExportStore'),
  withCallState(),
  withProps(() => ({
    overviewService: inject(OverviewService),
  })),

  withMethods(({ overviewService, ...store }) => ({
    downloadReport: rxMethod<{
      filters: OverviewFilters;
      exportType?: ExportType;
    }>(
      pipe(
        tap(() => {
          patchState(store, setLoading());
        }),
        exhaustMap(({ filters, exportType = 'darbu' }) =>
          overviewService.exportReport(filters, exportType).pipe(
            tapResponse({
              complete: () => {
                patchState(store, setLoaded());
              },
              error: (error) => {
                patchState(store, setError(error));
              },

              next: (blob) => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const startDate =
                  filters.startDate?.toLocaleDateString('en-CA')?.trim() ?? '';
                const endDate =
                  filters.endDate?.toLocaleDateString('en-CA')?.trim() ?? '';

                link.download = `${exportType}_parskats_${startDate}-${endDate}.xlsx`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(url);
              },
            }),
          ),
        ),
      ),
    ),
  })),
);
